'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';

import 'angular-validation-match';

import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import dashboard from './account/dashboard/dashboard.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import maps from './maps/maps.component';

// Directives 
import bcnavbar from '../components/directives/bcnavbar/bcnavbar.directive';
import sidebarnav from '../components/directives/sidebarnav/sidebarnav.directive';

// Services
import baseConfigService from '../components/services/baseConfig/baseConfig.service';
import feedbackService from '../components/services/feedbackService/feedbackService.service';
import navService from '../components/services/navService/navService.service';


import './app.css';
import './main/main.css';

angular.module('epsMobileApp', [ngCookies, ngResource, ngSanitize, uiRouter, _Auth, account, admin,
  'validation.match', navbar, footer, main, maps, dashboard, bcnavbar,sidebarnav, baseConfigService, navService,
  feedbackService, constants, util
])
  .config(routeConfig)
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    // $rootScope.$on('$stateChangeStart', function(event, next) {
    //   Auth.isLoggedIn(function(loggedIn) {
    //     if(next.authenticate && !loggedIn) {
    //       $location.path('/login');
    //     }
    //   });
    // });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['epsMobileApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js